import { forward } from 'effector';
import { loaderEffects } from 'stores/loader';
import { settingsWalletPinEffects } from 'stores/settings/wallet-pin';

forward({
    from: settingsWalletPinEffects.changeWalletPinFx.pending,
    to: loaderEffects.loaderFx
});
